import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggle() {
    this.element.classList.toggle('expanded')
    
    // Re-apply alternating row colors after expanding/collapsing
    this.updateAlternatingRows()
  }
  
  updateAlternatingRows() {
    const visibleRows = document.querySelectorAll("li.header-result:not([style*='display: none'])")
    
    // Remove existing alternating classes
    visibleRows.forEach(row => row.classList.remove('row-even'))
    
    // Apply alternating classes based on visible position
    visibleRows.forEach((row, index) => {
      if (index % 2 === 0) {
        row.classList.add('row-even')
      }
    })
  }
}
